export const contactInfoAnime = {
  from: {
    scaleX: 0,
  },
  to: {
    scaleX: 1,
    transition: {
      delay: 0.3,
    },
  },
};
